import React from 'react';
import { getIndex } from '../autocomplete.helpers';
export function useList(state, props) {
    var getOptions = state.getOptions;
    var _a = React.useState(null), displayIndex = _a[0], setDisplayIndex = _a[1];
    function onkey(event) {
        var index = getIndex(getOptions(), displayIndex, event);
        if (typeof index == 'number')
            select(index);
    }
    function select(index) {
        setDisplayIndex(index);
    }
    return {
        index: displayIndex,
        select: select,
        onKeyDown: onkey,
    };
}
